import { DataServer } from "../../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

interface InspectionBoqExcelFileState {
  InspectionBoqExcelFile: {
    load: boolean;
    data: [];
  };
}

export const InspectionBoqExcelFileSlice = createSlice({
  name: "InspectionBoqExcelFile",
  initialState: {
    InspectionBoqExcelFile: {
      load: false,
      data: [],
    },
  } as InspectionBoqExcelFileState,
  reducers: {
    resetInspectionBoqExcelFileState: (state: any) => {
        state.InspectionBoqExcelFile.data = [];
    },
},
  extraReducers: (builder: any) => {
    builder
      .addCase(fetchInspectionBoqExcelFile.pending, (state: InspectionBoqExcelFileState) => {
        state.InspectionBoqExcelFile.load = true;
      })
      .addCase(fetchInspectionBoqExcelFile.fulfilled, (state: InspectionBoqExcelFileState, action: any) => {
        state.InspectionBoqExcelFile.data = action.payload;
        state.InspectionBoqExcelFile.load = false;
      })
      .addCase(fetchInspectionBoqExcelFile.rejected, (state: InspectionBoqExcelFileState) => {
        state.InspectionBoqExcelFile.load = false;
      })
      .addCase(fetchStockExcelFile.pending, (state: InspectionBoqExcelFileState) => {
        state.InspectionBoqExcelFile.load = true;
      })
      .addCase(fetchStockExcelFile.fulfilled, (state: InspectionBoqExcelFileState, action: any) => {
        state.InspectionBoqExcelFile.data = action.payload;
        state.InspectionBoqExcelFile.load = false;
      })
      .addCase(fetchStockExcelFile.rejected, (state: InspectionBoqExcelFileState) => {
        state.InspectionBoqExcelFile.load = false;
      })
  },
});

export const { resetInspectionBoqExcelFileState } = InspectionBoqExcelFileSlice.actions;
export default InspectionBoqExcelFileSlice.reducer;

export const fetchInspectionBoqExcelFile = createAsyncThunk(
  "InspectionBoqExcelFile/fetchInspectionBoqExcelFile",
  async (param: { apiParam : {warehouse_id: any, tpi_firm_id: any, project_pin: any} }, thunkAPI) => {
    try {      
      const { data } = await DataServer.post("api/getInspectionBoqExcelFile", {
        warehouse_id: param.apiParam.warehouse_id,
        tpi_firm_id: param.apiParam.tpi_firm_id,
        project_pin: param.apiParam.project_pin
      });
      return data;

    } catch (error) {
      return(error);
    }
  }
);


export const fetchStockExcelFile = createAsyncThunk(
  "InspectionBoqExcelFile/fetchStockExcelFile",
  async (param: { apiParam : {warehouse_id: any} }, thunkAPI) => {
    try {      
      const { data } = await DataServer.post("api/downloadStockInsights", {
        warehouse_id: param.apiParam.warehouse_id
      });
      return data;

    } catch (error) {
      return(error);
    }
  }
);
